import axios, { AxiosResponse } from 'axios';

export interface IVyjadreni {
    vyjadreni: string;
}

const vyjadreniCdcpApi = (id: number) => {
    return axios({
        method: 'GET',
        url: `/AML/${id}/vyjadreni`
    }).then((resp: AxiosResponse<IVyjadreni>) => resp.data);
};
export const vyjadreniCdcpIsinApi = (id: number) => {
    return axios({
        method: 'GET',
        url: `/ISIN/${id}/Vyjadreni`
    }).then((resp: AxiosResponse<IVyjadreni>) => resp.data);
};

export default vyjadreniCdcpApi;
